var map = {
	"./bird 11.jpg": 80394,
	"./birds (2).jpg": 42196,
	"./boy 4.jpg": 78489,
	"./butter fly.jpg": 93382,
	"./fox 2.jpg": 9790,
	"./fox 3.jpg": 64571,
	"./fox 4.jpg": 41896,
	"./plan mt.jpg": 94047,
	"./rocket 2.jpg": 55045,
	"./rocket 3.jpg": 27432,
	"./uc browser 1.jpg": 98214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82505;